import { ViewStyle } from "react-native";
import { ThemeStyle, ClassGroupType } from "../../Style.types";

export interface IButtonIconClassGroup {
  btnIcon: ThemeStyle;
  btnIconPrimary: ThemeStyle;
  btnIconSecondary: ThemeStyle;
  btnIconNeutralLighter: ThemeStyle;
  btnIconNeutralDarker: ThemeStyle;
  btnIconSuccess: ThemeStyle;
  btnIconWarning: ThemeStyle;
  btnIconDanger: ThemeStyle;
  btnIconInfo: ThemeStyle;
  btnIconOutlinePrimary: ThemeStyle;
  btnIconOutlineSecondary: ThemeStyle;
  btnIconOutlineNeutralLighter: ThemeStyle;
  btnIconOutlineNeutralDarker: ThemeStyle;
  btnIconOutlineSuccess: ThemeStyle;
  btnIconOutlineWarning: ThemeStyle;
  btnIconOutlineDanger: ThemeStyle;
  btnIconOutlineInfo: ThemeStyle;
  btnIconTextPrimary: ThemeStyle;
  btnIconTextSecondary: ThemeStyle;
  btnIconTextNeutralLighter: ThemeStyle;
  btnIconTextNeutralDarker: ThemeStyle;
  btnIconTextSuccess: ThemeStyle;
  btnIconTextWarning: ThemeStyle;
  btnIconTextDanger: ThemeStyle;
  btnIconTextInfo: ThemeStyle;
  btnIconXSmall: ThemeStyle;
  btnIconSmall: ThemeStyle;
  btnIconMedium: ThemeStyle;
  btnIconLarge: ThemeStyle;
  btnIconDisabled: ThemeStyle;
  btnIconOutlineDisabled: ThemeStyle;
  btnIconTextDisabled: ThemeStyle;
  btnIconBlock: ViewStyle;
}

export const ButtonIconClassGroup: ClassGroupType<IButtonIconClassGroup> = {
  btnIcon: (theme) => ({
    fontFamily: theme.fonts.primary.bold,
    display: "flex",
    flexDirection: "row",
    alignSelf: "flex-start",
    alignItems: "center",
    position: "relative",
    gap: theme.fonts.baseSize * 0.5,
  }),
  btnIconBlock: {
    alignSelf: "stretch",
    justifyContent: "center",
  },
  btnIconPrimary: (theme) => ({
    backgroundColor: theme.colors.primary.main,
    color: theme.colors.primary.contrast,
  }),
  btnIconSecondary: (theme) => ({
    backgroundColor: theme.colors.secondary.main,
    color: theme.colors.secondary.contrast,
  }),
  btnIconNeutralLighter: (theme) => ({
    backgroundColor: theme.colors.neutralLighter.main,
    color: theme.colors.neutralLighter.contrast,
  }),
  btnIconNeutralDarker: (theme) => ({
    backgroundColor: theme.colors.neutralDarker.main,
    color: theme.colors.neutralDarker.contrast,
  }),
  btnIconSuccess: (theme) => ({
    backgroundColor: theme.colors.success.main,
    color: theme.colors.success.contrast,
  }),
  btnIconWarning: (theme) => ({
    backgroundColor: theme.colors.warning.main,
    color: theme.colors.warning.contrast,
  }),
  btnIconDanger: (theme) => ({
    backgroundColor: theme.colors.danger.main,
    color: theme.colors.danger.contrast,
  }),
  btnIconInfo: (theme) => ({
    backgroundColor: theme.colors.info.main,
    color: theme.colors.info.contrast,
  }),
  btnIconTextPrimary: (theme) => ({
    backgroundColor: "transparent",
    color: theme.colors.primary.main,
  }),
  btnIconTextSecondary: (theme) => ({
    backgroundColor: "transparent",
    color: theme.colors.secondary.main,
  }),
  btnIconTextNeutralLighter: (theme) => ({
    backgroundColor: "transparent",
    color: theme.colors.neutralLighter.main,
  }),
  btnIconTextNeutralDarker: (theme) => ({
    backgroundColor: "transparent",
    color: theme.colors.neutralDarker.main,
  }),
  btnIconTextSuccess: (theme) => ({
    backgroundColor: "transparent",
    color: theme.colors.success.main,
  }),
  btnIconTextWarning: (theme) => ({
    backgroundColor: "transparent",
    color: theme.colors.warning.main,
  }),
  btnIconTextDanger: (theme) => ({
    backgroundColor: "transparent",
    color: theme.colors.danger.main,
  }),
  btnIconTextInfo: (theme) => ({
    backgroundColor: "transparent",
    color: theme.colors.info.main,
  }),
  btnIconDisabled: (theme) => ({
    backgroundColor: theme.colors.neutralLighter.dark,
    color: theme.colors.neutralDarker.light,
  }),
  btnIconOutlineDisabled: (theme) => ({
    backgroundColor: "transparent",
    borderColor: theme.colors.neutralLighter.dark,
    color: theme.colors.neutralLighter.dark,
  }),
  btnIconTextDisabled: (theme) => ({
    backgroundColor: "transparent",
    color: theme.colors.neutralDarker.light,
  }),
  btnIconXSmall: (theme) => ({
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 8,
    paddingRight: 8,
    fontSize: theme.fonts.baseSize * 0.875,
    borderRadius: 8,
  }),

  btnIconSmall: (theme) => ({
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 8,
    paddingRight: 8,
    fontSize: theme.fonts.baseSize,
    borderRadius: 8,
  }),
  btnIconMedium: (theme) => ({
    paddingTop: 16,
    paddingBottom: 16,
    paddingLeft: 16,
    paddingRight: 16,
    fontSize: theme.fonts.baseSize,
    borderRadius: 8,
  }),
  btnIconLarge: (theme) => ({
    paddingTop: 16,
    paddingBottom: 16,
    paddingLeft: 16,
    paddingRight: 16,
    fontSize: theme.fonts.baseSize * 1.125,
    borderRadius: 8,
  }),
  btnIconOutlinePrimary: (theme) => ({
    backgroundColor: "transparent",
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: theme.colors.primary.main,
    color: theme.colors.primary.main,
  }),
  btnIconOutlineSecondary: (theme) => ({
    backgroundColor: "transparent",
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: theme.colors.secondary.main,
    color: theme.colors.secondary.main,
  }),
  btnIconOutlineNeutralLighter: (theme) => ({
    backgroundColor: "transparent",
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: theme.colors.neutralLighter.main,
    color: theme.colors.neutralLighter.main,
  }),
  btnIconOutlineNeutralDarker: (theme) => ({
    backgroundColor: "transparent",
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: theme.colors.neutralDarker.main,
    color: theme.colors.neutralDarker.main,
  }),
  btnIconOutlineSuccess: (theme) => ({
    backgroundColor: "transparent",
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: theme.colors.success.main,
    color: theme.colors.success.main,
  }),
  btnIconOutlineWarning: (theme) => ({
    backgroundColor: "transparent",
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: theme.colors.warning.main,
    color: theme.colors.warning.main,
  }),
  btnIconOutlineDanger: (theme) => ({
    backgroundColor: "transparent",
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: theme.colors.danger.main,
    color: theme.colors.danger.main,
  }),
  btnIconOutlineInfo: (theme) => ({
    backgroundColor: "transparent",
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: theme.colors.info.main,
    color: theme.colors.info.main,
  }),
};
